// extracted by mini-css-extract-plugin
export default {"input":"Input_input__-fsv9","container":"Input_container__tC60t","label":"Input_label__pn-+O","grey":"Input_grey__YvvlD"};